import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import * as Colors from '../../utils/Color';
import { Field } from 'react-form';
import { validate } from '../../utils/validation';
import { connect } from 'react-redux';


const styles = {
    errorStyle: {
        color: Colors.error,
    },
    underlineStyle: {
        borderColor: Colors.grey
    },
    underlineFocusStyle: {
        borderColor: Colors.primary
    },
    floatingLabelStyle: {
        fontWeight: 'bold',
        color: Colors.grey50
    },
    hintLabelStyle: {
        fontWeight: 'bold',
        color: Colors.grey50
    },
    floatingLabelFocusStyle: {
        color: Colors.grey50,
        fontSize: '18px'
    }
};



class TextFields extends Component {
    componentDidMount(){

        if (this.props.defaultValue && this.props.formApi) {
            this.props.formApi.setValue(this.props.field, this.props.defaultValue);
        }
    }

    render() {
        return (
            <Field validate={ value => validate(value, this.props.validations) } field={ this.props.field } >
                { fieldApi => {
                    const { setValue, setTouched, error } = fieldApi;

                    return (
                        <TextField
                            inputStyle={this.props.arb ? {direction: 'rtl'} : null}
                            style={this.props.hide ? {display: 'none'} : null}
                            defaultValue={this.props.defaultValue}
                            disabled={this.props.disabled}
                            hintText={ this.props.hintText }
                            hintStyle={ styles.hintLabelStyle }
                            onBlur={ e => setTouched() }
                            onChange={e => setValue(e.target.value)}
                            errorText={ this.props.error && this.props.error[this.props.field] ? this.props.error[this.props.field] : error }
                            type={ this.props.type }
                            fullWidth={ true }
                            className="text-field"
                            floatingLabelText={ this.props.label }
                            underlineStyle={ styles.underlineStyle }
                            underlineFocusStyle={ styles.underlineFocusStyle }
                            floatingLabelStyle={ styles.floatingLabelStyle }
                            floatingLabelFocusStyle={ styles.floatingLabelFocusStyle }
                        />
                    );
                }}
            </Field>
        );
    }
}

const mapStateToProps = state => {
  return {
      error: state.auth.error
  }
};


export default connect(mapStateToProps)( TextFields );


// WEBPACK FOOTER //
// ./src/components/UI/TextFiled.js